import React from 'react';

/**
 * Pied de page commun à la landing et aux pages éditoriales.
 *
 * Factorisé au moment où la FAQ est sortie de la landing pour devenir
 * /questions-frequentes : les deux pages doivent porter les mêmes liens légaux.
 */
const LIENS = [
  { href: '/questions-frequentes', libelle: 'Questions fréquentes' },
  { href: '/mentions-legales', libelle: 'Mentions légales' },
  { href: '/confidentialite', libelle: 'Politique de confidentialité' },
];

const SiteFooter = () => (
  <footer className="bg-white border-t border-gray-200 py-8">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <p className="text-center text-gray-600 mb-2">
        © {new Date().getFullYear()} Anti-Recouvrement.com — Sequana SASU
      </p>
      <p className="text-center text-gray-500 text-sm mb-4">
        Information juridique • Ne remplace pas les conseils d'un avocat
      </p>
      <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm">
        {LIENS.map(({ href, libelle }) => (
          <a key={href} href={href} className="text-gray-500 hover:text-blue-600 transition-colors">
            {libelle}
          </a>
        ))}
      </div>
    </div>
  </footer>
);

export default SiteFooter;
